import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/subscriptions/:subscriptionId/export-pdf`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const exportPDF = {
  post: apiPathFunc(pathBase),
};
